/*
 * @Author: cxy
 * @Desc:
 * @Date: 2024-08-06 16:37:26
 * @LastEditTime: 2024-08-07 21:04:43
 */
import { computed } from '@vue/composition-api'
import store from '@/store/'

export default () => {
  const computedData = {
    // 平台分类
    PLATFORM: computed(() => store.state.label.data.CONTACT?.PLATFORM),
    FORMAT: computed(() => store.state.label.data.CONTACT?.FORMAT),

  }
    function showName(type, id) {
      const item = computedData[type].value.filter((item) => item.key === Number(id))[0]
      return (item && item.value) || '--'
    }
  return {
    ...computedData,
    showName,
  }
}
